"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var BASE_CLASS_NAME = "sidebar-unsplash-collection";
var UnsplashCollection = function (props) {
    var _a;
    var _b = __read((0, react_1.useState)(false), 2), hasImageLoaded = _b[0], setHasImageLoaded = _b[1];
    var handleImageLoaded = function (imageUrl) {
        var img = new window.Image();
        img.onload = function () {
            setHasImageLoaded(true);
        };
        img.src = imageUrl;
    };
    handleImageLoaded(props.collection.thumbnailUrl);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__header") },
                react_1.default.createElement("span", { className: "".concat(BASE_CLASS_NAME, "__name") }, props.collection.title),
                react_1.default.createElement("span", { className: "".concat(BASE_CLASS_NAME, "__count") },
                    "(",
                    props.collection.count,
                    ")")),
            react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: "".concat(BASE_CLASS_NAME, "__thumb"), onClick: props.onClick },
                react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
                        _a["".concat(BASE_CLASS_NAME, "__image_loaded")] = hasImageLoaded,
                        _a["".concat(BASE_CLASS_NAME, "__image")] = true,
                        _a)), style: {
                        backgroundImage: hasImageLoaded ? "url(\"".concat(props.collection.thumbnailUrl, "\")") : "",
                    } }),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__button") },
                    react_1.default.createElement(kaleidoscope_1.Button, { as: "div", type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.XSmall }, "View collection"))))));
};
exports.default = UnsplashCollection;
